import { animate, delay } from "motion";
import { VideoPlayer } from "./player";

document.addEventListener("DOMContentLoaded", function () {
    const headerWithVideo = document.querySelector(".header-with-video");
    if (!headerWithVideo) return;

    const video = headerWithVideo.querySelector(".header-with-video__video");
    const buttonPlay = headerWithVideo.querySelector(".header-with-video__play");
    const dialog = headerWithVideo.querySelector(".header-with-video__dialog");
    const buttonClose = headerWithVideo.querySelector(".header-with-video__close");
    const buttonScrollIndicator = headerWithVideo.querySelector(
        ".header-with-video__scroll-indicator"
    );
    const player = new VideoPlayer(dialog.querySelector(".player"));

    const handleDialogOpen = () => {
        window.scrollTo({
            top: headerWithVideo.offsetTop,
        });
        dialog.showModal();
        player.play();
    };

    const handleDialogClose = () => {
        dialog.close();
        player.pause();
    };

    const handleScrollIndicatorClick = () => {
        window.scrollTo({
            top: headerWithVideo.offsetTop + headerWithVideo.clientHeight,
        });
    };

    buttonPlay.addEventListener("click", handleDialogOpen);

    dialog.addEventListener("cancel", handleDialogClose);

    buttonClose.addEventListener("click", handleDialogClose);

    buttonScrollIndicator.addEventListener("click", handleScrollIndicatorClick);

    animate(
        [
            [
                video,
                {
                    width: ["calc(12% + 0px)", "calc(96% + 0px)"],
                    height: [
                        "calc(22svh + 0px)",
                        window.innerWidth >= 1024 ? "calc(84% + 0px)" : "calc(84svh + 0px)",
                    ],
                    opacity: [0, 1],
                },
                {
                    duration: 1,
                },
            ],
            [
                video,
                {
                    width: "calc(100% + 2px)",
                    height: window.innerWidth >= 1024 ? "calc(100% + 2px)" : "calc(100svh + 2px)",
                },
                {
                    duration: 0.5,
                    at: "+0.5",
                },
            ],
            [
                buttonPlay,
                {
                    y: [100, 0],
                    opacity: [0, 1],
                },
                {
                    duration: 0.5,
                    at: "<",
                },
            ],
            [
                buttonScrollIndicator,
                {
                    opacity: [0, 1],
                },
                {
                    duration: 0.5,
                },
            ],
        ],
        {
            onPlay: () => {
                headerWithVideo.classList.add("header-with-video--anim");
                delay(() => video.play(), 1);
                delay(() => headerWithVideo.classList.remove("header-with-video--anim"), 1.5);
            },
        }
    );
});
